export const GET_ADMIN_USER_LIST = `query($first:Int, $last:Int, $after:Cursor, $before:Cursor, $filter: UserFilter,$getUserType: Int!) {
    getAdminUserList(first:$first, last:$last, after:$after, before:$before, filter:$filter,getUserType:$getUserType){
        nodes {
          id
          firstName
          lastName
          country
          createdAt
          email
          userType
          isServiceUser
          status
          phone
          lastLogin
          loginCount
          adminPermissions
        }
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
    }
  }`;

export const GET_EXCEL_ADMIN_USER_LIST = `query($filter: UserFilter, $getUserType: Int!) {
    getAdminUserList(filter:$filter, getUserType:$getUserType, excludeCurrentUser:false){
        nodes {
          id
          firstName
          lastName
          country
          createdAt
          email
          userType
          isServiceUser
          status
          phone
          lastLogin
          loginCount
          adminPermissions
          userByCreatorUserId{
            firstName
            lastName
          }
        }
    }
  }`;

export const CREATE_SITE_ADMIN = `mutation($user: CreateAdminUserInput!){
    createAdminUser(input:$user){
      user{
        id
      }
    }
  }`;

export const CREATE_SYSTEM_ADMIN = `
    mutation ($user: CreateSystemAdminUserInput!) {
        createSystemAdminUser(input: $user) {
            user {
                id
            }
        }
    }
`;

export const UPDATE_SITE_ADMIN_USER = `mutation($id: UUID!, $userPatch: UserPatch!){
    updateUserById(input:{
      id:$id,
      userPatch: $userPatch
    })
    {
      user {
        id
        firstName
        lastName
        country
        createdAt
        email
        status
        phone
        lastLogin
        loginCount
        adminPermissions
      }
    }
  }`;

export const RESET_PASSWORD = `mutation($userId: UUID! $password: String! $minLength: String!){ 
	reassignPassword(input:{
	userId:$userId,
	newPassword:$password,
	minLength:$minLength
}){string}
}`;

export const UPDATE_PERMISSIONS = `mutation(
  $userId:UUID!
  $countryPermissions:[String]!
  $adminPermissions:[String]!
  $userPermissions:[String]!
  $readPermissions:[String]!
  $basicAuthPermissions: [String]!
  ){
  updatePermissions(input:{userId:$userId,adminPermissions:$adminPermissions,readPermissions:$readPermissions,userPermissions:$userPermissions,countryPermissions:$countryPermissions,basicAuthPermissions:$basicAuthPermissions}){
    allPermission{
      adminPermissions
      userPermissions
      readPermissions
      countryPermissions
      basicAuthPermissions
    }
  }
}`;

export const CREATE_USER_MANAGER = `mutation($user: RegisterNewUserInput!){
    registerNewUser(input:$user){
        user{
            id
        }
    }
}`;
